import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IMeetingsJobDetails, IUploadMeetingsJobResult } from '../../../../api/jobs.dao';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../../jobs-monitor-host.viewmodel';
import { AlertErrorMessage } from '../../../global/modal/alerts-host/types/alert/alert-error-message';

const meetingsUploadJobProperties : IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IMeetingsJobDetails>> = {
    reviewFailedJobButtonText: 'Ok',
    reviewCompletedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IMeetingsJobDetails, IUploadMeetingsJobResult>) => {
        return (
            <div className='meetings-upload-result-alert'>
                <div>
                    <FormattedMessage
                        id='oe.meetings.created'
                        defaultMessage='Meetings created: {count}'
                        description='Upload meetings modal body'
                        values={{
                            count: props.result.createdMeetingCount
                        }}
                    />
                </div>
                <div>
                    <FormattedMessage
                        id='oe.meetings.updated'
                        defaultMessage='Meetings updated: {count}'
                        description='Upload meetings modal body'
                        values={{
                            count: props.result.updatedMeetingCount
                        }}
                    />
                </div>
                <div>
                    <FormattedMessage
                        id='oe.organizations.created'
                        defaultMessage='Organizations created: {count}'
                        description='Upload organizations modal body'
                        values={{
                            count: props.result.createdOrganizationCount
                        }}
                    />
                </div>
                <div>
                    <FormattedMessage
                        id='oe.organizations.updated'
                        defaultMessage='Organizations updated: {count}'
                        description='Upload organizations modal body'
                        values={{
                            count: props.result.updatedOrganizationCount
                        }}
                    />
                </div>
                <div>
                    <FormattedMessage
                        id='oe.attendees.created'
                        defaultMessage='Attendees created: {count}'
                        description='Upload attendees modal body'
                        values={{
                            count: props.result.createdAttendeeCount
                        }}
                    />
                </div>
                <div>
                    <FormattedMessage
                        id='oe.attendees.updated'
                        defaultMessage='Attendees updated: {count}'
                        description='Upload attendees modal body'
                        values={{
                            count: props.result.updatedAttendeeCount
                        }}
                    />
                </div>
            </div>
        );
    },
    failedComponent: (props: IJobResultComponentProps<IMeetingsJobDetails, IUploadMeetingsJobResult>) => {
        return <AlertErrorMessage title='Schedule Upload Failed' message={props.result?.failureReason || 'Unknown failure reason'} />;
    },
};

export { meetingsUploadJobProperties };